<template>
  <div id='repHeader'>
    <table>
    <thead>
    <tr>
      <th class="hitem"></th>
      <th class="hitem">{{ getUserName }} | {{ getDistCode }} | <router-link to="/signout">{{ $t("Menu.signout") }}</router-link></th>
    </tr>
    </thead>
    </table>
  </div>
</template>

<script>
import CONST from '../const/const.js'  // 定数

export default {
  name: 'repHeader',

  /*
   * computed: 算出プロパティ
   */
  computed: {
    // ユーザー名取得
    getUserName: function() {
      var userInfo = this.$store.state.user;
      var user = '';
console.log(userInfo);

      if (userInfo) {
        if(userInfo['group'] === CONST.USER_KBN.SALES) {
          // 販売店ユーザ
          user = userInfo['custom:name'];
        } else {
          // 開発者ユーザ
          user = userInfo.username;
        }
      }

      return user;
    },

    // 販売店コード取得
    getDistCode: function() {
//console.log(this.$store.state.user);
      var distCode = this.$store.state.user['custom:distCode'];
      if (distCode) {
        return distCode;
      }

      // 取得できない場合は開発ユーザ
      return '-----';
    },
  },
}
</script>

<style lang="scss">
/*--------------------
   BASIC CLASSES
--------------------*/
#repHeader {
  max-width: 640px;
  margin: 0 auto;
}
/*--------------------
   FORM STYLING
--------------------*/
/* SEARCH CONDITION */
thead th.hitem {
//  width: 140px;
  border: 0px solid #000000;
  text-align: right;
  font-size: 11px;
  line-height: 20px;
}
</style>
